import { ErrorMessage } from 'formik'
import TextError from './TextError'
import { useStyles } from './styles'
import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'

const SelectStateField = (props) => {
  const classes = useStyles()
  const { label, name, onValueChange, ...rest } = props

  const dropDownOptions = [
    {
      key: 'Massachusetts',
      value: 'MA',
    },
    {
      key: 'Rhode Island',
      value: 'RI',
    },
    {
      key: 'Connecticut',
      value: 'CT',
    },
  ]

  return (
    <div className={classes.formFieldStateOptions}>
      <InputLabel htmlFor={name} className={classes.formLabel}>
        {label}
        <ErrorMessage name={name} component={TextError} />
      </InputLabel>
      <FormControl>
        <InputLabel id="label">Homeowner's State</InputLabel>
        <Select
          labelid="label"
          id={name}
          name={name}
          {...rest}
          onChange={(event) => {
            onValueChange(event)
          }}
          disabled={true}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          SelectDisplayProps={{ "data-testid": name }}
        >
          {dropDownOptions.map((option) => {
            return (
              <MenuItem key={option.key} value={option.value}>
                {option.key}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </div>
  )
}

export default SelectStateField
